(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["uplift-complete-set"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmtParts(sample) {
      var m = sample && sample.match(/^(\D*)1(\D?)000(\D*)$/);
      return m ? { prefix: m[1], sep: m[2], suffix: m[3] } : { prefix: '', sep: ' ', suffix: ' kr' };
    }
    function money(cents, parts) {
      return parts.prefix + String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, parts.sep) + parts.suffix;
    }
    function tier(extras, totalM, full, part) { return extras === 0 ? 0 : (extras >= totalM ? full : part); }

    function wire(root) {
      if (root.__uset) return; root.__uset = 1;
      var cards = [].slice.call(root.querySelectorAll('[data-uset-card]'));
      var addBtn = root.querySelector('[data-uset-add]');
      var nowEl = root.querySelector('[data-uset-now]');
      var wasEl = root.querySelector('[data-uset-was]');
      var savered = root.querySelector('[data-uset-savered]');
      var saveamt = root.querySelector('[data-uset-saveamt]');
      var fill = root.querySelector('[data-uset-fill]');
      var msg = root.querySelector('[data-uset-msg]');
      var pctFull = +root.getAttribute('data-pct-full') || 10;
      var pctPart = +root.getAttribute('data-pct-part') || 5;
      var showDisc = root.getAttribute('data-show-discount') === '1';
      var tmpl = fmtParts(root.getAttribute('data-money-sample'));

      var idInput = document.querySelector('product-form-component [name="id"], form[action*="/cart/add"] [name="id"]');

      cards.forEach(function (card) {
        var vs = []; var vj = card.querySelector('.uset__v'); if (vj) { try { vs = JSON.parse(vj.textContent); } catch (e) {} }
        var oc = +card.getAttribute('data-oc') || 0;
        var co = +card.getAttribute('data-co');
        var anchor = card.hasAttribute('data-uset-anchor');
        var sel = [null, null, null];
        card.__vs = vs; card.__anchor = anchor;

        if (anchor) {
          var prices = {}; var pj = card.querySelector('.uset__anchorv'); if (pj) { try { prices = JSON.parse(pj.textContent); } catch (e) {} }
          card.__vid = function () { return (idInput && idInput.value) ? idInput.value : card.getAttribute('data-vid'); };
          var avar = card.querySelector('[data-uset-avar]'), cp = card.querySelector('[data-uset-price]');
          card.__syncAnchor = function () {
            var id = card.__vid();
            if (id && prices[id] != null) { card.setAttribute('data-price', prices[id]); if (cp) cp.textContent = money(prices[id], tmpl); }
            var opt = vs.filter(function (v) { return String(v.id) === String(id); })[0];
            if (opt && avar) avar.textContent = opt.o.filter(Boolean).join(' · ');
          };
          return;
        }

        // preselect first available for each option
        card.querySelectorAll('.uset__size').forEach(function (s) { sel[+s.getAttribute('data-oi')] = s.value; });
        card.__sel = sel;

        function resolve() {
          for (var k = 0; k < oc; k++) { if (!sel[k]) return null; }
          return vs.filter(function (v) { for (var k = 0; k < oc; k++) { if (v.o[k] !== sel[k]) return false; } return true; })[0] || null;
        }
        card.__resolve = resolve;
        card.__isOn = function () { return !card.classList.contains('is-off'); };
        function refreshPrice() {
          var v = resolve(); var cp = card.querySelector('[data-uset-price]');
          if (v) { card.setAttribute('data-price', v.p); if (cp) cp.textContent = money(v.p, tmpl); }
        }
        var cardImg = card.querySelector('.uset__img');
        card.querySelectorAll('.uset__size').forEach(function (s) {
          s.addEventListener('change', function () {
            sel[+s.getAttribute('data-oi')] = s.value;
            if (s.getAttribute('data-colour') === '1') {
              var opt = s.options[s.selectedIndex]; var im = opt && opt.getAttribute('data-img');
              if (im && cardImg) { cardImg.src = im; cardImg.removeAttribute('srcset'); }
            }
            refreshPrice(); calc();
          });
        });
        var ck = card.querySelector('[data-uset-toggle]');
        if (ck) {
          var toggle = function () {
            var off = !card.classList.contains('is-off');
            card.classList.toggle('is-off', off); ck.setAttribute('aria-pressed', off ? 'false' : 'true'); calc();
          };
          ck.addEventListener('click', toggle);
          ck.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
        }
      });

      function calc() {
        var total = 0, extras = 0, totalM = 0;
        cards.forEach(function (c) {
          if (c.__anchor) { total += +c.getAttribute('data-price') || 0; return; }
          totalM++;
          if (c.__isOn()) { total += +c.getAttribute('data-price') || 0; extras++; }
        });
        var pct = showDisc ? tier(extras, totalM, pctFull, pctPart) : 0;
        var d = Math.round(total * (1 - pct / 100));
        if (nowEl) nowEl.textContent = money(d, tmpl);
        if (wasEl) { if (pct > 0) { wasEl.textContent = money(total, tmpl); wasEl.hidden = false; } else wasEl.hidden = true; }
        if (savered) savered.hidden = pct === 0;
        if (saveamt && pct > 0) saveamt.textContent = money(total - d, tmpl);
        if (fill) fill.style.width = Math.min(100, Math.round(extras / totalM * 100)) + '%';
        if (msg) {
          var esc = function (s) { return s.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
          var mAdd = esc(root.getAttribute('data-t-add') || 'Add');
          var mMore = esc(root.getAttribute('data-t-more') || '1 more');
          msg.innerHTML = extras === 0
            ? (mAdd + ' → <b>−' + pctPart + '%</b>')
            : (extras < totalM ? (mMore + ' → <b>−' + pctFull + '%</b>') : ('<b>−' + pctFull + '%</b> ✓'));
        }
        addBtn.__pct = pct;
      }

      cards.forEach(function (c) { var pe = c.querySelector('[data-uset-price]'); if (pe) pe.textContent = money(+c.getAttribute('data-price') || 0, tmpl); });

      // keep anchor synced to the PDP variant picker
      var anchorCard = cards.filter(function (c) { return c.__anchor; })[0];
      if (anchorCard && idInput) {
        var sync = function () { anchorCard.__syncAnchor(); calc(); };
        idInput.addEventListener('change', sync);
        if (window.MutationObserver) new MutationObserver(sync).observe(idInput, { attributes: true, attributeFilter: ['value'] });
        anchorCard.__syncAnchor();
      }
      calc();

      function openDrawer() { var t = document.querySelector('[aria-controls="cart-drawer"], [on\\:click="#cart-drawer/toggle"]'); if (t) t.click(); }

      addBtn.addEventListener('click', function () {
        var items = [], needCard = null;
        cards.forEach(function (c) {
          if (c.__anchor) { var id = c.__vid(); if (id) items.push({ id: +id, quantity: 1 }); return; }
          if (!c.__isOn()) return;
          var v = c.__resolve();
          if (!v || !v.a) { if (!needCard) needCard = c; return; }
          items.push({ id: v.id, quantity: 1 });
        });
        if (needCard) { needCard.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (!items.length) return;
        addBtn.disabled = true;
        var pct = addBtn.__pct || 0;
        var code = pct >= pctFull ? root.getAttribute('data-code-full') : (pct > 0 ? root.getAttribute('data-code-part') : '');
        var addReq = fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items, sections: ['cart-drawer-section'], sections_url: location.pathname })
        }).then(function (r) { return r.json(); });
        // apply discount code (if configured) in parallel so the cart reflects it
        var codeReq = code ? fetch('/discount/' + encodeURIComponent(code), { method: 'GET' }).catch(function () {}) : Promise.resolve();
        Promise.all([addReq, codeReq]).then(function (res) {
          var d = res[0]; addBtn.disabled = false;
          if (d && d.status) return;
          // re-fetch the drawer section so an applied code shows the discounted total
          if (code) {
            fetch('/?section_id=cart-drawer-section').then(function (r) { return r.text(); }).then(function (html) { morph(html); openDrawer(); });
          } else {
            if (d.sections && d.sections['cart-drawer-section']) morph(d.sections['cart-drawer-section']);
            openDrawer();
          }
        }).catch(function () { addBtn.disabled = false; });
      });

      function morph(html) {
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
        var live = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (fresh && live) live.replaceWith(fresh);
      }
    }
    function boot() { document.querySelectorAll('[data-uset-root]').forEach(wire); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-klaviyo-bis"] && !Shopify.designMode) return;
  try {
    (function () {
    var SEL = 'product-form-component [name="id"], form[action*="/cart/add"] [name="id"]';
    var REVISION = '2024-06-15';
    function currentId() {
      var el = document.querySelector(SEL);
      return el ? String(el.value || '') : '';
    }
    function init(root) {
      if (root.__upliftBis) return;
      root.__upliftBis = 1;
      var cfg = {};
      try { cfg = JSON.parse(root.getAttribute('data-bis') || '{}'); } catch (e) {}
      var avail = cfg.avail || {}, vt = cfg.vt || {}, s = cfg.s || {};
      // Shopify's | t HTML-escapes text (You&#39;re); decode it for textContent.
      for (var k in s) s[k] = new DOMParser().parseFromString(s[k], 'text/html').documentElement.textContent;
      var company = cfg.company || '', list = cfg.list || '';
      var trigger = root.querySelector('[data-bis-trigger]');
      var modal = root.querySelector('[data-bis-modal]');
      var vEl = root.querySelector('[data-bis-variant]');
      var input = root.querySelector('[data-bis-email]');
      var submit = root.querySelector('[data-bis-submit]');
      var msg = root.querySelector('[data-bis-msg]');

      function sync() {
        var id = currentId();
        var soldOut = id && avail[id] === false;
        root.hidden = !soldOut;
        if (!soldOut && !modal.hidden) closeModal();
      }
      function setMsg(text, ok) {
        msg.textContent = text || '';
        msg.className = 'uplift-bis__msg ' + (ok ? 'uplift-bis__msg--ok' : 'uplift-bis__msg--err');
      }
      function openModal() {
        setMsg('', false); msg.textContent = '';
        input.hidden = false; input.disabled = false; submit.hidden = false; submit.disabled = false;
        vEl.textContent = vt[currentId()] || '';
        modal.hidden = false; setTimeout(function () { input.focus(); }, 30);
      }
      function closeModal() { modal.hidden = true; }

      // ponytail: 500ms poll of the hidden variant id — simplest reliable cross-theme
      // signal on Horizon (value set as a property, so change/mutation is inconsistent).
      var last = currentId();
      document.addEventListener('change', function () { setTimeout(sync, 50); }, true);
      setInterval(function () { var c = currentId(); if (c !== last) { last = c; sync(); } }, 500);

      trigger.addEventListener('click', openModal);
      root.querySelectorAll('[data-bis-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

      function post(url, body) {
        return fetch(url + '?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': REVISION },
          body: JSON.stringify(body)
        });
      }
      submit.addEventListener('click', function () {
        var email = (input.value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { setMsg(s.invalid, false); return; }
        var id = currentId();
        if (!id) { setMsg(s.invalid, false); return; }
        submit.disabled = true;

        // 1) Back-in-stock subscription → "Subscribed to Back in Stock" → the flow.
        var bis = post('https://a.klaviyo.com/client/back-in-stock-subscriptions/', {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } } }
          }
        });
        // 2) Marketing consent → subscribe to the configured list (a no-Welcome-flow
        //    list, e.g. BACK IN STOCK) so notify-me signups don't trigger Welcome.
        if (list) {
          post('https://a.klaviyo.com/client/subscriptions/', {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Back in Stock',
                profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          }).catch(function () {});
        }

        bis.then(function (r) {
          if (r.ok) { setMsg(s.success, true); input.value = ''; input.hidden = true; submit.hidden = true; }
          else { setMsg(s.error, false); submit.disabled = false; }
        }).catch(function () { setMsg(s.error, false); submit.disabled = false; });
      });

      sync();
    }
    function boot() { document.querySelectorAll('[data-bis-root]').forEach(init); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-model-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    var desktop = window.matchMedia('(min-width: 750px)');
    function target() {
      var g = document.querySelector('media-gallery');
      if (!g) return null;
      // only the selected colour's images have a size
      var vis = Array.prototype.filter.call(g.querySelectorAll('.product-media-container'), function (e) { return e.getBoundingClientRect().width > 0; });
      if (!desktop.matches) return vis[0] || g; // mobile: bottom-left of the first image (scrolls away with it)
      var tpl = document.querySelector('.uplift-mb-src [data-uplift-mb]');
      var idx = tpl && tpl.dataset.image === '1' ? 0 : 1;
      return vis[idx] || vis[0] || g;
    }
    function inject() {
      var tpl = document.querySelector('.uplift-mb-src [data-uplift-mb]');
      if (!tpl) return;
      var t = target();
      if (!t) return;
      var live = document.querySelector('.uplift-mb--live');
      if (live) { if (live.parentElement === t) return; live.remove(); }
      if (getComputedStyle(t).position === 'static') t.style.position = 'relative';
      var clone = tpl.cloneNode(true);
      clone.removeAttribute('data-uplift-mb');
      clone.classList.add('uplift-mb--live');
      t.appendChild(clone);
      fit();
    }
    // phone: one line only, inside image 1 - the full sentence when it fits, otherwise the short one
    // ("Clara-Sofie · 171 cm · str. S"), shrunk a little if even that doesn't fit
    function fit() {
      var live = document.querySelector('.uplift-mb--live');
      if (!live) return;
      live.style.fontSize = '';
      if (desktop.matches) return;
      live.classList.remove('uplift-mb--long', 'uplift-mb--mid');
      live.classList.add('uplift-mb--long');
      if (live.scrollWidth <= live.clientWidth + 1) return;
      live.classList.remove('uplift-mb--long');
      live.classList.add('uplift-mb--mid');
      if (live.scrollWidth <= live.clientWidth + 1) return;
      live.classList.remove('uplift-mb--mid');
      var fs = parseFloat(getComputedStyle(live).fontSize) || 13;
      while (live.scrollWidth > live.clientWidth + 1 && fs > 9) { fs -= 0.5; live.style.fontSize = fs + 'px'; }
    }
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || window.setTimeout)(function () { queued = false; inject(); colourText(); }, 0);
    }
    function boot() {
      if (!document.querySelector('.uplift-mb-src [data-uplift-mb]')) return;
      inject(); colourText();
      if (!window.__upliftMbObs) {
        var scope = document.querySelector('#MainContent') || document.body;
        try {
          // re-attach after colour switches (the visible images change) — inject() is a no-op when already in place
          window.__upliftMbObs = new MutationObserver(schedule);
          window.__upliftMbObs.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
        } catch (e) { window.__upliftMbObs = null; }
      }
    }
    // colour switch: show the model of the selected colour (map from data-by-color, "Colour|sentence;;" pairs)
    function colourText() {
      var tpl = document.querySelector('.uplift-mb-src [data-uplift-mb]');
      if (!tpl || !tpl.dataset.byColor) return;
      var map = {};
      tpl.dataset.byColor.split(';;').forEach(function (l) { var i = l.indexOf('|'); if (i > 0) map[l.slice(0, i)] = l.slice(i + 1); });
      var picked = Array.prototype.map.call(document.querySelectorAll('variant-picker input:checked, variant-picker select'), function (e) { return e.value; });
      var hit = null, skip = false;
      for (var i = 0; i < picked.length; i++) if (map[picked[i]]) { hit = map[picked[i]]; break; }
      if (hit === '__skip__') { hit = null; skip = true; }
      // colour-only products (SKI): no badge for colours without a confirmed model; skipped colours never
      var hide = skip || (!hit && tpl.hasAttribute('data-colour-only'));
      document.querySelectorAll('.uplift-mb--live').forEach(function (el) { el.classList.toggle('uplift-mb--hide', hide); });
      if (hit) {
        var parts = hit.split('||'), full = parts[0], short = parts[1] || parts[0], mid = parts[2] || full;
        document.querySelectorAll('.uplift-mb__m').forEach(function (el) { if (el.textContent !== mid) el.textContent = mid; });
        document.querySelectorAll('.uplift-mb__l').forEach(function (el) { if (el.textContent !== full) el.textContent = full; });
        document.querySelectorAll('.uplift-mb__s').forEach(function (el) { if (el.textContent !== short) el.textContent = short; });
      }
      fit();
    }
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-picker')) setTimeout(colourText, 0); }, true);
    document.addEventListener('variant:update', function () { setTimeout(colourText, 0); });
    boot();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    setTimeout(inject, 600);
    setTimeout(inject, 1600);
    if (desktop.addEventListener) desktop.addEventListener('change', function () { inject(); fit(); });
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-payment-perks"] && !Shopify.designMode) return;
  try {
    /* Same-day dispatch countdown (merged from the old Ship & Stock block). Namespaced so it
     never collides with other block bundles. Ticks only while on-screen and the tab is visible. */
  (function () {
    var DTF = Intl.DateTimeFormat;
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function PpShip(root) {
      var d = root.dataset;
      this.root = root;
      this.cfg = {
        hour: isNaN(parseInt(d.cutoffHour, 10)) ? 14 : parseInt(d.cutoffHour, 10),
        tz: d.timezone || 'Europe/Oslo',
        weekdays: d.weekdays === 'true',
        timeFormat: d.timeFormat || 'units_no',
        showArrival: d.showArrival === 'true',
        onlyBefore: d.onlyBefore === 'true',
        transitMin: parseInt(d.transitMin, 10) || 0,
        transitMax: parseInt(d.transitMax, 10) || 0,
        extraDays: parseInt(d.extraDays, 10) || 0,
        shipLead: d.shipLead || '', shipTrail: d.shipTrail || '', shipAfter: d.shipAfter || '', arrivalLead: d.arrivalLead || '',
        hourUnit: d.hourUnit || 'h'
      };
      this.textEl = root.querySelector('[data-pp-ship-text]');
      this.arrEl = root.querySelector('[data-pp-ship-arr]');
      var loc = document.documentElement.lang || undefined;
      this.fmts = {
        zoned: new DTF('en-GB', { timeZone: this.cfg.tz, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }),
        dateShort: new DTF(loc, { timeZone: this.cfg.tz, weekday: 'short', day: 'numeric' }),
        dateMonth: new DTF(loc, { timeZone: this.cfg.tz, weekday: 'short', day: 'numeric', month: 'short' }),
        dispatch: new DTF(loc, { timeZone: this.cfg.tz, weekday: 'long', day: 'numeric', month: 'short' })
      };
      this.onScreen = true;
      this.timer = null;
      var self = this;
      this.onVis = function () { self.evalTimer(); };
      document.addEventListener('visibilitychange', this.onVis);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) { self.onScreen = !!(es[0] && es[0].isIntersecting); self.evalTimer(); });
        this.io.observe(root);
      }
      this.evalTimer();
    }
    PpShip.prototype.evalTimer = function () {
      if (!document.body.contains(this.root)) { // detached on section re-render → tear down, no leak
        this.stop();
        if (this.io) { this.io.disconnect(); this.io = null; }
        document.removeEventListener('visibilitychange', this.onVis);
        return;
      }
      // A row hidden by "only before cutoff" is never on-screen, so keep ticking while hidden
      // (cheap) so it re-appears by itself at midnight / next dispatch day.
      if ((this.onScreen || this.root.hidden) && document.visibilityState !== 'hidden') this.start(); else this.stop();
    };
    PpShip.prototype.start = function () {
      if (this.timer || !this.textEl) return;
      var self = this;
      this.tick();
      this.timer = setInterval(function () { self.tick(); }, 1000);
    };
    PpShip.prototype.stop = function () { if (this.timer) { clearInterval(this.timer); this.timer = null; } };
    PpShip.prototype.zonedNow = function () {
      var parts = this.fmts.zoned.formatToParts(new Date());
      var get = function (t) { return (parts.filter(function (p) { return p.type === t; })[0] || {}).value; };
      var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { dow: days[get('weekday')], h: +get('hour'), m: +get('minute'), s: +get('second') };
    };
    PpShip.prototype.isDispatchDay = function (dow) { return !this.cfg.weekdays || (dow >= 1 && dow <= 5); };
    PpShip.prototype.dispatchOffset = function (n, secsNow, cutoff) {
      if (this.isDispatchDay(n.dow) && secsNow < cutoff) return 0;
      for (var i = 1; i <= 7; i++) { if (this.isDispatchDay((n.dow + i) % 7)) return i; }
      return 1;
    };
    PpShip.prototype.addTransit = function (baseDow, startOffset, days) {
      var off = startOffset, added = 0;
      while (added < days) { off += 1; var dd = (baseDow + off) % 7; if (!this.cfg.weekdays || (dd >= 1 && dd <= 5)) added++; }
      return off;
    };
    PpShip.prototype.fmtDate = function (off, withMonth) {
      var dt = new Date(Date.now() + off * 86400000);
      return (withMonth ? this.fmts.dateMonth : this.fmts.dateShort).format(dt);
    };
    PpShip.prototype.fmtTime = function (hh, mm, ss) {
      var pad = function (x) { return String(x).padStart(2, '0'); };
      if (this.cfg.timeFormat === 'clock') return pad(hh) + ':' + pad(mm) + ':' + pad(ss);
      // units_no = local short hour unit from the locale file (uplift.perks.hour_unit: t in nb/da, h in sv/en).
      var u = this.cfg.timeFormat === 'units_en' ? ['h', 'm', 's'] : [this.cfg.hourUnit, 'm', 's'];
      // mm/ss always 2 digits: keeps the line width constant so the arrival text
      // doesn't flip between fitting and wrapping as the digits change each second.
      return hh + u[0] + ' ' + pad(mm) + u[1] + ' ' + pad(ss) + u[2];
    };
    PpShip.prototype.tick = function () {
      if (!document.body.contains(this.root)) { this.stop(); return; }
      var n = this.zonedNow();
      var secsNow = n.h * 3600 + n.m * 60 + n.s;
      var cutoff = this.cfg.hour * 3600;
      var live = this.isDispatchDay(n.dow) && secsNow < cutoff;
      if (this.cfg.onlyBefore) { this.root.hidden = !live; if (!live) return; } // hide row (+ its divider via CSS) after cutoff
      if (live) {
        var rem = cutoff - secsNow;
        var hh = Math.floor(rem / 3600); rem %= 3600;
        var mm = Math.floor(rem / 60);
        var ss = rem % 60;
        this.textEl.innerHTML = esc(this.cfg.shipLead) + ' <strong>' + this.fmtTime(hh, mm, ss) + '</strong> ' + esc(this.cfg.shipTrail);
      } else {
        var dOff0 = this.dispatchOffset(n, secsNow, cutoff);
        this.textEl.innerHTML = esc(this.cfg.shipAfter) + ' <strong>' + esc(this.fmts.dispatch.format(new Date(Date.now() + dOff0 * 86400000))) + '</strong>';
      }
      if (this.arrEl && this.cfg.showArrival) {
        var dOff = this.dispatchOffset(n, secsNow, cutoff);
        var startOff = this.addTransit(n.dow, dOff, this.cfg.transitMin);
        var endOff = this.addTransit(n.dow, dOff, this.cfg.transitMax + this.cfg.extraDays);
        var range = startOff === endOff ? this.fmtDate(endOff, true) : this.fmtDate(startOff, /^en/.test(document.documentElement.lang || '')) + ' – ' + this.fmtDate(endOff, true) // English needs the month on both ends ("Wed, Sep 16 – Fri, Sep 18");
        this.arrEl.textContent = '— ' + this.cfg.arrivalLead + ' ' + range;
      }
    };
    function init(scope) {
      (scope || document).querySelectorAll('[data-pp-ship]').forEach(function (el) { if (!el.__ppShip) el.__ppShip = new PpShip(el); });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-review-info"] && !Shopify.designMode) return;
  try {
    class UpliftReviewInfo {
    constructor(root) {
      this.track = root.querySelector('[data-uplift-track]');
      if (!this.track) return;
      var wrap = root.querySelector('[data-uplift-reviews]');
      if (wrap && wrap.getAttribute('data-uplift-source') !== 'manual') {
        var want = parseInt(wrap.getAttribute('data-uplift-count'), 10) || 4;
        var autoCards = [].slice.call(this.track.querySelectorAll('[data-uplift-auto]'));
        var arr = autoCards.slice();
        for (var i = arr.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
        }
        var keep = arr.slice(0, want);
        autoCards.forEach(function (c) {
          if (keep.indexOf(c) === -1) { c.parentNode.removeChild(c); }
          else { c.removeAttribute('hidden'); }
        });
      }
      this.arrows = [].slice.call(root.querySelectorAll('[data-uplift-rev]'));
      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => {
          var dir = btn.dataset.upliftRev === 'next' ? 1 : -1;
          var card = this.track.querySelector('.uplift-ri__card');
          var amount = card ? card.getBoundingClientRect().width + 12 : 300;
          this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
        });
      });
      this.updateArrows();
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
    }
    updateArrows() {
      if (!this.arrows || !this.arrows.length) return;
      var overflow = this.track.scrollWidth - this.track.clientWidth - 2;
      this.arrows.forEach((a) => { a.hidden = overflow <= 0; });
    }
  }
  // Review card → jump to the full reviews section. Delegated on document so it survives
  // Horizon's section re-render on variant change (which replaces the card nodes).
  if (!document.__upliftRiCardNav) {
    document.__upliftRiCardNav = true;
    var upliftRiGo = function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('.uplift-ri__card');
      if (!card) return;
      var wrap = card.closest('[data-uplift-anchor]');
      var anchor = wrap && wrap.getAttribute('data-uplift-anchor');
      var target = anchor && document.querySelector(anchor);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    document.addEventListener('click', upliftRiGo);
    document.addEventListener('keydown', upliftRiGo);
  }
  function upliftInitReviewInfo(scope) {
    (scope || document).querySelectorAll('.uplift-ri').forEach((el) => {
      if (!el.upliftReviewInfo) el.upliftReviewInfo = new UpliftReviewInfo(el);
    });
  }
  upliftInitReviewInfo();
  document.addEventListener('shopify:section:load', (event) => {
    upliftInitReviewInfo(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-save-badge"] && !Shopify.designMode) return;
  try {
    // Price / compare-at / savings are server-rendered for one variant. Horizon only morphs its own
  // variant picker on change, so swap this block from the section HTML it already fetched.
  if (!document.__upliftSaveSync) {
    document.__upliftSaveSync = true;
    document.addEventListener("shopify:product:select", function (e) {
      if (!e.target.closest || e.target.closest("product-card, dialog") || !e.promise) return;
      e.promise.then(function (r) {
        var html = r && r.detail && r.detail.html;
        if (!html) return;
        document.querySelectorAll("[data-uplift-save]").forEach(function (cur) {
          var next = html.querySelector("[data-uplift-save=\"" + cur.getAttribute("data-uplift-save") + "\"]");
          if (next && next.innerHTML !== cur.innerHTML) cur.innerHTML = next.innerHTML;
        });
      }).catch(function () {});
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-set"] && !Shopify.designMode) return;
  try {
    (function () {
    // Money in the store's own format (e.g. "1 234 568 kr" / "€1.234.567,89"): learn prefix, thousands
    // separator, decimal separator and suffix from a formatted sample of 1234567.89. Whole amounts print
    // without decimals (like money_without_trailing_zeros); cents only when there are any (EUR prices).
    function moneyFormatter(sample) {
      var m = /^(.*?)1(\D?)234\2(?:567|568)(?:(\D)89)?(.*)$/.exec(sample || ''); // 568: no-decimals formats round up
      if (!m) return function (c) { return String(Math.round(c / 100)); };
      return function (cents) {
        var frac = m[3] ? Math.round(cents % 100) : 0;
        var whole = frac ? Math.floor(cents / 100) : Math.round(cents / 100);
        var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
        return m[1] + s + (frac ? m[3] + (frac < 10 ? '0' : '') + frac : '') + m[4];
      };
    }

    function wire(root) {
      if (root.__upliftSet) return;
      root.__upliftSet = true;
      var pct = parseFloat(root.dataset.pct) || 0;
      var money = moneyFormatter(root.dataset.money);
      var btn = root.querySelector('[data-set-add]');
      var errEl = root.querySelector('[data-set-error]');

      var items = [].slice.call(root.querySelectorAll('[data-set-item]')).map(function (el) {
        var variants = JSON.parse(el.querySelector('[data-set-variants]').textContent);
        var ci = +el.dataset.colorIndex;
        var sizeK = [].map.call(el.querySelectorAll('.uplift-set__select[data-size]'), function (s) { return +s.dataset.opt; });
        // Values no live variant has (discontinued) are removed, not hidden: iOS ignores hidden on <option>.
        el.querySelectorAll('.uplift-set__swatch, .uplift-set__select option').forEach(function (n) {
          var k = +(n.dataset.opt || n.closest('select').dataset.opt), val = n.dataset.val || n.value;
          if (val && !variants.some(function (x) { return x.o[k] === val; })) n.remove();
        });
        var n = variants[0] ? variants[0].o.length : 0;
        var sel = [];
        for (var k = 0; k < n; k++) sel.push(null);
        // Single-variant products are complete from the start.
        if (variants.length === 1) sel = variants[0].o.slice();
        // Start on the first in-stock variant's colour.
        var first = variants.filter(function (v) { return v.a; })[0] || variants[0];
        if (ci >= 0 && first) sel[ci] = first.o[ci];
        return { el: el, variants: variants, ci: ci, sel: sel, sizeK: sizeK };
      });

      // A value is pickable if an in-stock variant has it and matches the other choices so far.
      function ok(it, k, val) {
        return it.variants.some(function (v) {
          if (!v.a || v.o[k] !== val) return false;
          for (var j = 0; j < v.o.length; j++) if (j !== k && it.sel[j] !== null && it.sel[j] !== v.o[j]) return false;
          return true;
        });
      }
      // An option with only ONE pickable value (in stock, consistent with the other choices) is chosen
      // for the shopper — e.g. Length when only Regular is left. Never the size: shoppers pick sizes.
      function autofill(it) {
        var changed = true;
        while (changed) {
          changed = false;
          for (var k = 0; k < it.sel.length; k++) {
            if (it.sel[k] !== null || it.sizeK.indexOf(k) >= 0) continue;
            var vals = [];
            it.variants.forEach(function (v) { if (vals.indexOf(v.o[k]) < 0 && ok(it, k, v.o[k])) vals.push(v.o[k]); });
            if (vals.length === 1) { it.sel[k] = vals[0]; changed = true; }
          }
        }
      }
      function chosen(it) {
        return it.variants.filter(function (v) {
          for (var j = 0; j < v.o.length; j++) if (it.sel[j] !== v.o[j]) return false;
          return true;
        })[0];
      }
      function preview(it) { // best match for price/photo while options are still open
        return chosen(it) || it.variants.filter(function (v) { return it.ci < 0 || v.o[it.ci] === it.sel[it.ci]; })[0] || it.variants[0] || null;
      }

      function render() {
        var full = 0, ready = true, anyPiece = true;
        items.forEach(function (it) {
          var v = chosen(it), pv = preview(it);
          if (!pv) { ready = false; anyPiece = false; return; } // no usable variant at all
          if (!(v && v.a)) ready = false;
          if (!it.variants.some(function (x) { return x.a; })) anyPiece = false;
          full += pv.p;
          it.el.querySelector('[data-set-price]').textContent = money(pv.p);
          var link = it.el.querySelector('.uplift-set__name'); // product page opens on the same colour/size
          if (link && pv.id) link.href = link.dataset.url + '?variant=' + pv.id;
          it.el.querySelector('[data-set-color-label]').textContent = it.ci >= 0 ? (it.sel[it.ci] || '') : '';
          var img = it.el.querySelector('[data-set-img]');
          var src = pv.img || (it.variants.filter(function (x) { return it.ci >= 0 && x.o[it.ci] === it.sel[it.ci] && x.img; })[0] || {}).img;
          if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
          it.el.querySelectorAll('.uplift-set__swatch').forEach(function (b) {
            var k = +b.dataset.opt;
            b.setAttribute('aria-pressed', String(it.sel[k] === b.dataset.val));
            b.disabled = !it.variants.some(function (x) { return x.a && x.o[k] === b.dataset.val; });
          });
          it.el.querySelectorAll('.uplift-set__select').forEach(function (s) {
            var k = +s.dataset.opt;
            [].forEach.call(s.options, function (o) {
              if (!o.value) return;
              o.disabled = !ok(it, k, o.value);
            });
            s.value = it.sel[k] || '';
            s.classList.toggle('is-empty', !it.sel[k]);
          });
        });
        var save = Math.round(full * pct / 100);
        var set = function (sel, txt) { var e = root.querySelector(sel); if (e) e.textContent = txt; };
        set('[data-set-save]', pct > 0 ? money(save) : '');
        set('[data-set-disc]', '−' + money(save));
        set('[data-set-full]', money(full));
        set('[data-set-total]', money(full - save));
        btn.setAttribute('aria-disabled', String(!ready));
        btn.textContent = !anyPiece ? btn.dataset.soldout : ready ? btn.dataset.add : btn.dataset.choose;
      }

      function change(it, k, val) {
        it.sel[k] = val;
        // Drop other choices that no longer exist / are sold out with the new value.
        for (var j = 0; j < it.sel.length; j++) if (j !== k && it.sel[j] !== null && !ok(it, j, it.sel[j])) it.sel[j] = null;
        autofill(it);
        errEl.hidden = true;
        render();
      }

      items.forEach(function (it) {
        it.el.addEventListener('click', function (e) {
          var b = e.target.closest('.uplift-set__swatch');
          if (b && !b.disabled) change(it, +b.dataset.opt, b.dataset.val);
        });
        it.el.addEventListener('change', function (e) {
          if (e.target.matches('.uplift-set__select')) change(it, +e.target.dataset.opt, e.target.value || null);
        });
      });

      items.forEach(autofill);

      // Same drawer refresh as the cart upsell: swap the drawer contents, update the bag count, open it.
      function swapDrawer(html) {
        var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
        var live = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (fresh && live) live.replaceWith(fresh);
        return !!(fresh && live);
      }
      function refreshDrawer(open, swapped) {
        var R = (window.Theme && Theme.routes) || {};
        // Whenever we have no fresh drawer markup (422 path, or Shopify omitted `sections`), re-render it from the server.
        var p = swapped ? Promise.resolve() : fetch(location.pathname + '?section_id=cart-drawer-section').then(function (r) { return r.text(); }).then(swapDrawer).catch(function () {});
        p.then(function () { return fetch((R.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } }); }).then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('cart-icon').forEach(function (icon) { if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(c.item_count); });
        }).catch(function () {});
        if (!open) return;
        var drawer = document.querySelector('cart-drawer-component');
        drawer = drawer && drawer.closest('theme-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(); else location.href = R.cart_url || '/cart';
      }

      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') {
          // Point the shopper at the first unfinished dropdown.
          var todo = root.querySelector('.uplift-set__select.is-empty');
          if (todo) todo.focus();
          return;
        }
        btn.setAttribute('aria-disabled', 'true');
        var lines = items.map(function (it) { return { id: chosen(it).id, quantity: 1 }; });
        var R = (window.Theme && Theme.routes) || {};
        fetch(R.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines, sections: ['cart-drawer-section'], sections_url: location.pathname })
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d.status) { errEl.textContent = d.description || d.message || ''; errEl.hidden = false; render(); refreshDrawer(false, false); return; }
          refreshDrawer(true, swapDrawer(d.sections && d.sections['cart-drawer-section']));
          render();
        }).catch(function () { errEl.textContent = btn.dataset.err; errEl.hidden = false; render(); });
      });

      root.__upliftRender = render;
      render();
    }

    function init(scope) { (scope || document).querySelectorAll('[data-uplift-set]').forEach(wire); }
    init();
    // Back/forward-cache restore can revive stale dropdown values; re-render so they match the state.
    window.addEventListener('pageshow', function (e) { if (e.persisted) document.querySelectorAll('[data-uplift-set]').forEach(function (r) { if (r.__upliftRender) r.__upliftRender(); }); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    var CACHE = {};
    var CACHE_VER = '6';
    // Cached for the whole visit (sessionStorage). Guide edits show on the next visit.
    // 1) Preferred: the guides are a THEME-LEVEL section ("uplift-size-guides", content in settings_data,
    //    edited on the size-guide page). Shopify renders it by name from any URL in the visitor's language —
    //    ~10 KB, no theme-specific ids, survives theme copies/updates.
    // 2) Legacy fallback (guides still inside a page TEMPLATE): that section's id carries a template number
    //    that changes per theme, so it's learned from one full-page fetch and remembered per theme.
    var THEME = (window.Shopify && Shopify.theme && Shopify.theme.id) || '';
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function sidKey(src) { return 'usg:sid:' + THEME + ':' + src; }
    function fetchText(url) {
      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.ok ? r.text() : ''; });
    }
    function hasGuides(t) { return t && t.indexOf('data-usg-guide') > -1; }
    function fetchLegacy(src) {
      var sid = null;
      try { sid = localStorage.getItem(sidKey(src)); } catch (e) {}
      var viaSection = sid
        ? fetchText(src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid)).then(function (t) { return hasGuides(t) ? t : ''; })
        : Promise.resolve('');
      return viaSection.then(function (t) {
        if (t) return t;
        try { localStorage.removeItem(sidKey(src)); } catch (e) {}
        return fetchText(src).then(function (html) {
          // The section wrapping the guides = the last section id opened before the first guide.
          var gi = html.indexOf('data-usg-guide');
          var si = gi > -1 ? html.lastIndexOf('id="shopify-section-', gi) : -1;
          var m = si > -1 ? html.slice(si).match(/^id="shopify-section-([^"]+)"/) : null;
          if (m) { try { localStorage.setItem(sidKey(src), m[1]); } catch (e) {} }
          return html;
        });
      });
    }
    function fetchGuidesHtml(src) {
      return fetchText(ROOT + '?section_id=uplift-size-guides').then(function (t) {
        return hasGuides(t) ? t : fetchLegacy(src);
      });
    }
    function loadGuides(src) {
      if (CACHE[src]) return CACHE[src];
      var skey = 'usg:' + CACHE_VER + ':' + src;
      try {
        var hit = sessionStorage.getItem(skey);
        if (hit) {
          var parsed = JSON.parse(hit);
          if (parsed && parsed.g) { CACHE[src] = Promise.resolve({ guides: parsed.g, footer: parsed.f || '' }); return CACHE[src]; }
        }
      } catch (e) {}
      CACHE[src] = fetchGuidesHtml(src)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var guides = [];
          doc.querySelectorAll('[data-usg-guide]').forEach(function (g) {
            var titleEl = g.querySelector('[data-usg-title]');
            var bodyEl = g.querySelector('[data-usg-body]');
            var match = (g.getAttribute('data-match') || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
            guides.push({
              key: (g.getAttribute('data-key') || '').toLowerCase(),
              match: match,
              title: titleEl ? titleEl.textContent.trim() : '',
              body: bodyEl ? bodyEl.innerHTML : g.innerHTML
            });
          });
          var footEl = doc.querySelector('[data-usg-footer]');
          var footer = footEl ? footEl.innerHTML : '';
          try { sessionStorage.setItem(skey, JSON.stringify({ t: Date.now(), g: guides, f: footer })); } catch (e) {}
          return { guides: guides, footer: footer };
        }).catch(function () { return { guides: [], footer: '' }; });
      return CACHE[src];
    }
    function pick(guides, key, type, tags) {
      if (key) { var byKey = guides.filter(function (g) { return g.key === key; })[0]; if (byKey) return byKey; }
      var tagList = (tags || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      for (var i = 0; i < guides.length; i++) {
        var g = guides[i];
        if (type && g.match.indexOf(type) > -1) return g;
        for (var j = 0; j < tagList.length; j++) { if (g.match.indexOf(tagList[j]) > -1) return g; }
      }
      return null;
    }
    function wire(root) {
      if (root.__sgWired) return; root.__sgWired = 1;
      var dlg = root.querySelector('[data-sg-dialog]');
      if (!dlg) return;
      var body = root.querySelector('[data-sg-body]');
      var titleEl = root.querySelector('[data-sg-title]');
      var bar = root.querySelector('[data-sg-bar]');
      var src = root.getAttribute('data-sg-src');
      var type = (root.getAttribute('data-sg-type') || '').toLowerCase();
      var tags = root.getAttribute('data-sg-tags') || '';
      var okey = (root.getAttribute('data-sg-key') || '').toLowerCase();
      var product = root.getAttribute('data-sg-product') || '';
      var append = root.getAttribute('data-sg-append') === '1';
      var filled = false;

      function resolve() {
        if (root.__guidePromise) return root.__guidePromise;
        root.__guidePromise = loadGuides(src).then(function (data) {
          var g = pick(data.guides, okey, type, tags);
          if (!g) { if (bar) bar.hidden = true; }
          root.__guide = g;
          root.__footer = data.footer || '';
          return g;
        });
        return root.__guidePromise;
      }
      if ('requestIdleCallback' in window) { requestIdleCallback(resolve, { timeout: 2000 }); } else { setTimeout(resolve, 1200); }

      function open() {
        resolve().then(function (g) {
          if (!g) return;
          if (!filled) {
            if (body) {
              body.innerHTML = g.body;
              if (root.__footer) { var f = document.createElement('div'); f.className = 'uplift-sg__footer'; f.innerHTML = root.__footer; body.appendChild(f); }
            }
            if (titleEl && g.title) { titleEl.textContent = append && product ? g.title + ' — ' + product : g.title; }
            filled = true;
          }
          if (dlg.showModal) { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
          document.documentElement.style.overflow = 'hidden';
        });
      }
      function close() { if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); } document.documentElement.style.overflow = ''; }
      root.querySelectorAll('[data-sg-open]').forEach(function (btn) { btn.addEventListener('click', open); });
      root.querySelectorAll('[data-sg-close]').forEach(function (btn) { btn.addEventListener('click', close); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    }
    /* Stock level (moved from the Ship & Stock block). Checked option inputs are read FIRST:
       they flip synchronously on click, while Horizon's hidden [name="id"] only updates after
       an async section re-render — reading it first made the first click render stale. */
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function wireStock(root) {
      var el = root.querySelector('[data-sg-stock]');
      if (!el || el.__sgsWired) return; el.__sgsWired = 1;
      var section = root.closest('.shopify-section') || document;
      var d = el.dataset;
      var cfg = {
        pid: d.sgsPid || '',
        low: parseInt(d.sgsLow, 10) || 15,
        high: parseInt(d.sgsHigh, 10) || 50,
        segments: parseInt(d.sgsSegments, 10) || 10,
        showVariant: d.sgsShowVariant === 'true',
        lowLead: d.sgsLowLead || '', lowTrail: d.sgsLowTrail || '',
        midLabel: d.sgsMidLabel || '', highLabel: d.sgsHighLabel || '', outLabel: d.sgsOutLabel || ''
      };
      var variants = [], swatches = {};
      try { variants = JSON.parse(el.querySelector('[data-sgs-variants]').textContent); } catch (e) {}
      try { swatches = JSON.parse(el.querySelector('[data-sgs-swatches]').textContent) || {}; } catch (e) {}
      // Small round swatch for the first option value that has one (e.g. the colour), placed before the title.
      function swatchFor(title) {
        var parts = title.split(' / ');
        for (var i = 0; i < parts.length; i++) {
          var bg = swatches[parts[i]];
          if (bg) return '<i class="uplift-sg__stock-sw" style="background:' + esc(bg).replace(/"/g, '&quot;') + '"></i>';
        }
        return '';
      }
      var barEl = el.querySelector('[data-sgs-bar]');
      var labEl = el.querySelector('[data-sgs-lab]');
      function currentVariant(preferId) {
        // 1) Variant id from Horizon itself (input data-variant-id on change, or the resolved
        //    product-select event) — exact even when an option has no input (single-value options).
        if (preferId) {
          var byPref = variants.filter(function (v) { return String(v.id) === String(preferId); })[0];
          if (byPref) return byPref;
        }
        var vp = section.querySelector('variant-picker[data-product-id="' + cfg.pid + '"]') || section.querySelector('variant-picker');
        if (vp) {
          var vals = [];
          vp.querySelectorAll('input:checked').forEach(function (i) { if (i.value) vals.push(i.value); });
          vp.querySelectorAll('select').forEach(function (s) { if (s.value) vals.push(s.value); });
          var t = vals.join(' / ');
          var match = variants.filter(function (v) { return v.title === t; })[0];
          if (match) return match;
        }
        var idEl = document.querySelector('product-form-component [name="id"], form[action*="/cart/add"] [name="id"]');
        if (idEl && idEl.value) {
          var byId = variants.filter(function (v) { return String(v.id) === String(idEl.value); })[0];
          if (byId) return byId;
        }
        return variants[0] || null;
      }
      function tierOf(v) {
        if (!v) return "high";
        if (v.a === false) return "out"; // Shopify availability (respects "continue selling" / pre-order)
        if (v.a !== true && v.tracked && v.qty <= 0) return "out";
        if (!v.tracked) return 'high';
        if (v.qty < cfg.low) return 'low';
        if (v.qty < cfg.high) return 'mid';
        return 'high';
      }
      function sync(preferId) {
        var v = currentVariant(typeof preferId === "string" || typeof preferId === "number" ? preferId : null);
        var tier = tierOf(v);
        var fill = { out: 0, low: 1 / 3, mid: 2 / 3, high: 1 };
        var lit = tier === 'out' ? 0 : Math.max(1, Math.round(cfg.segments * fill[tier]));
        el.classList.remove('is-out', 'is-low', 'is-mid', 'is-high');
        el.classList.add('is-' + tier);
        if (barEl) barEl.querySelectorAll('i').forEach(function (s, i) { s.classList.toggle('on', i < lit); });
        if (labEl) {
          var head;
          if (tier === 'out') head = esc(cfg.outLabel);
          else if (tier === 'low') head = esc(cfg.lowLead) + ' ' + v.qty + ' ' + esc(cfg.lowTrail);
          else if (tier === 'mid') head = esc(cfg.midLabel);
          else head = esc(cfg.highLabel);
          var lab = '<strong>' + head + '</strong>';
          if (cfg.showVariant && v && v.title && v.title !== 'Default Title') lab += ' <span class="var">— </span>' + swatchFor(v.title) + '<span class="var">' + esc(v.title) + '</span>'; // swatch outside the faded spans so it keeps full colour
          labEl.innerHTML = lab;
        }
      }
      section.addEventListener("change", function (e) { sync(e.target && e.target.dataset ? e.target.dataset.variantId : null); });
      // Re-sync once Horizon finishes its async variant update (authoritative variant id).
      section.addEventListener("shopify:product:select", function (e) {
        if (!e.target.closest || e.target.closest("product-card, dialog") || !e.promise) return;
        e.promise.then(function (r) { if (r && r.variant) sync(r.variant.id); }).catch(function () {});
      });
      sync();
    }
    function init(scope) { (scope || document).querySelectorAll('[data-sg-root]').forEach(function (r) { wire(r); wireStock(r); }); }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uplift-sticky-atc"] && !Shopify.designMode) return;
  try {
    class UpliftStickyAtc {
    constructor(root) {
      this.root = root;
      this.section = root.closest('.shopify-section') || document;
      this.bar = root.querySelector('[data-satc-bar]');
      this.btn = root.querySelector('[data-satc-add]');
      this.priceEl = root.querySelector('[data-satc-price]');
      this.compareEl = root.querySelector('[data-satc-compare]');
      this.imgEl = root.querySelector('[data-satc-img]');
      if (!this.bar || !this.btn) return;

      this.productId = root.dataset.productId;

      try {
        this.variants = JSON.parse(root.querySelector('[data-satc-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }

      try {
        this.swatches = JSON.parse(root.querySelector('[data-satc-swatches]').textContent);
      } catch (e) {
        this.swatches = [];
      }

      // Portal the bar to <body> so a transformed / container-query ancestor
      // (Horizon's product section) can't trap position:fixed inside itself.
      this.bar.dataset.satcPortal = this.productId || '1';
      document
        .querySelectorAll('body > [data-satc-portal="' + this.bar.dataset.satcPortal + '"]')
        .forEach((el) => el.remove());
      document.body.appendChild(this.bar);

      // Horizon's sticky header. We sit the bar directly beneath it.
      this.header = document.querySelector('header-component') || document.querySelector('#header-group');

      // Horizon scrolls a container (.page-wrapper on desktop), not the window,
      // so window.scrollY can stay 0. Listen on both and read whichever moves.
      this.scroller = document.querySelector('.page-wrapper');
      this.onScroll = this.onScroll.bind(this);
      // Remove the previous instance's listeners before adding (no accumulation on
      // repeated shopify:section:load — only one sticky bar is ever live).
      var prev = window.__satcListeners;
      if (prev) {
        window.removeEventListener('scroll', prev.fn);
        window.removeEventListener('resize', prev.fn);
        if (prev.scroller) prev.scroller.removeEventListener('scroll', prev.fn);
      }
      window.__satcListeners = { fn: this.onScroll, scroller: this.scroller };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      if (this.scroller) this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

      // Trigger: show once the main buy buttons scroll out of view — exactly like
      // Horizon's native sticky bar, so there are never two CTAs on screen at once.
      this.setupObserver();
      // Hide whenever a drawer / modal is open (cart, menu, size guide, quick add).
      this.mo = new MutationObserver(() => this.applyVisibility());
      this.mo.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });

      // Variant / quantity changes anywhere in the product section resync the bar.
      this.section.addEventListener("change", (e) => this.syncVariant(e.target && e.target.dataset ? e.target.dataset.variantId : null));
      // Re-sync once Horizon finishes its async variant update (authoritative variant id).
      this.section.addEventListener("shopify:product:select", (e) => {
        if (!e.target.closest || e.target.closest("product-card, dialog") || !e.promise) return;
        e.promise.then((r) => { if (r && r.variant) this.syncVariant(r.variant.id); }).catch(() => {});
      });
      this.btn.addEventListener('click', () => this.add());

      // Tapping the product info / image / variant area jumps back up to the
      // variant picker so the shopper can change size or colour. The CTA still adds.
      this.picker = this.section.querySelector('variant-picker[data-product-id="' + this.productId + '"]') || this.section.querySelector('variant-picker');
      ['[data-satc-img]', '.uplift-satc__info', '.uplift-satc__opts'].forEach((sel) => {
        var el = this.bar.querySelector(sel);
        if (!el) return;
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.addEventListener('click', () => this.scrollToPicker());
        el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.scrollToPicker(); } });
      });

      // Full mirror: re-copy the real page button whenever the theme mutates it
      // (label, "Adding…", disabled) so the sticky CTA is never out of step.
      const rb = this.realButton();
      if (rb) {
        this.btnMo = new MutationObserver(() => this.mirrorButton());
        this.btnMo.observe(rb, { attributes: true, childList: true, subtree: true, characterData: true });
      }

      this.syncVariant();
      this.applyVisibility();
    }

    buyButtonsTarget() {
      const block = this.section.querySelector('.buy-buttons-block');
      if (block) return block;
      const rb = this.realButton();
      return rb ? (rb.closest('.buy-buttons-block') || rb) : null;
    }

    scrollToPicker() {
      const t = this.picker || this.buyButtonsTarget();
      if (!t) return;
      try { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      catch (e) { t.scrollIntoView(); }
    }

    setupObserver() {
      const target = this.buyButtonsTarget();
      if (!target) return;
      this.buyTarget = target;
      // Same intersection root the theme uses: .page-wrapper on desktop, viewport on mobile.
      const root = window.matchMedia('(min-width: 990px)').matches
        ? document.querySelector('.page-wrapper')
        : null;
      this.io = new IntersectionObserver(
        (entries) => {
          const e = entries[0];
          if (!e) return;
          if (!e.isIntersecting) {
            const r = e.target.getBoundingClientRect();
            this.wantShow = r.bottom < 0 || r.top < 0; // only once scrolled PAST (above viewport)
          } else {
            this.wantShow = false;
          }
          this.applyVisibility();
        },
        { root: root }
      );
      this.io.observe(target);
    }

    drawerOpen() {
      // Cart drawer / mobile menu (Horizon's is a <details>, not a dialog) / any modal dialog (size guide, quick add).
      return !!document.querySelector('theme-drawer[open], dialog[open], header-drawer details[open]');
    }

    applyVisibility() {
      const show = !!this.wantShow && !this.drawerOpen();
      this.bar.dataset.stuck = show ? 'true' : 'false';
      this.updatePosition();
      if (show && !this.raf) this.loop();
    }

    updateWantShow() {
      const t = this.buyTarget || (this.buyTarget = this.buyButtonsTarget());
      if (!t) return;
      const r = t.getBoundingClientRect();
      const past = r.bottom < 0 || r.top < 0; // main buy button scrolled fully out of view
      if (past !== this.wantShow) {
        this.wantShow = past;
        this.applyVisibility();
      }
    }

    onScroll() {
      // Scroll-driven visibility fallback (robust on mobile, where the IO root differs),
      // and keep the bar glued to the header's live bottom edge as the page scrolls.
      this.updateWantShow();
      this.updatePosition();
      if (this.bar.dataset.stuck === 'true' && !this.raf) this.loop();
    }

    headerBottom() {
      // Use the header's live bottom while it's pinned at the top; otherwise fall
      // back to the theme's own --header-height so we never mis-measure to 0.
      if (this.header) {
        const r = this.header.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > 1) return r.bottom;
      }
      const h = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
      return Number.isFinite(h) && h > 0 ? h : 0;
    }

    updatePosition() {
      const show = this.bar.dataset.stuck === 'true';
      const hb = this.headerBottom();
      // Dock right under the header; reveal is a short slide + fade IN PLACE —
      // it never travels from the top of the page and never tucks under the header.
      this.bar.style.transform = 'translateY(' + (show ? hb : hb - 10) + 'px)';
      this.bar.style.opacity = show ? '1' : '0';
      // Hidden bar: out of Tab order and screen readers. Not while a drawer/dialog is open — the modal already blocks the page,
      // and the drawer hands focus back to the sticky button the moment it closes (before our observer re-runs).
      this.bar.inert = !show && !this.drawerOpen();
      return hb;
    }

    loop() {
      const top = this.updatePosition();
      if (this.bar.dataset.stuck !== 'true') { this.raf = null; return; }
      // Stop the loop once the header stops moving, restart on the next scroll.
      if (top !== this.prevTop) { this.settle = 0; } else { this.settle = (this.settle || 0) + 1; }
      this.prevTop = top;
      if (this.settle > 6) { this.raf = null; return; }
      this.raf = requestAnimationFrame(() => this.loop());
    }

    realButton() {
      return (
        this.section.querySelector('[ref="addToCartButton"]') ||
        this.section.querySelector('.add-to-cart-button') ||
        this.section.querySelector('form[action*="/cart/add"] [type="submit"]')
      );
    }

    mirrorButton() {
      const real = this.realButton();
      if (!real) return;
      // Copy the theme button's classes, label and disabled state so our CTA is
      // visually + textually identical to the page's. Clicking still puppets it.
      this.btn.className = 'uplift-satc__btn ' + real.className;
      this.btn.innerHTML = real.innerHTML;
      this.btn.disabled = real.disabled;
    }

    selectedTitle() {
      const vp =
        this.section.querySelector('variant-picker[data-product-id="' + this.productId + '"]') ||
        this.section.querySelector('variant-picker');
      if (!vp) return null;
      const vals = [];
      vp.querySelectorAll('input:checked').forEach((i) => { if (i.value) vals.push(i.value); });
      vp.querySelectorAll('select').forEach((s) => { if (s.value) vals.push(s.value); });
      return vals.length ? vals.join(' / ') : null;
    }

    currentVariant(preferId) {
      // Variant id from Horizon (option input data-variant-id / resolved product-select) wins —
      // exact even for single-value options that render no input.
      if (preferId) {
        const byPref = this.variants.find((v) => String(v.id) === String(preferId));
        if (byPref) return byPref;
      }
      // Checked option inputs FIRST (synchronous on click). Horizon's hidden [name="id"]
      // only updates after an async section re-render, so on `change` it still holds the
      // previous variant — reading it first made the first click render stale.
      const t = this.selectedTitle();
      if (t) {
        const match = this.variants.find((v) => v.title === t);
        if (match) return match;
      }
      const idEl = document.querySelector('product-form-component [name="id"], form[action*="/cart/add"] [name="id"]');
      if (idEl && idEl.value) {
        const byId = this.variants.find((v) => String(v.id) === String(idEl.value));
        if (byId) return byId;
      }
      if (this.variants.length === 1) return this.variants[0];
      return null;
    }

    syncVariant(preferId) {
      const v = this.currentVariant(preferId);
      if (v) {
        if (this.priceEl && v.price) this.priceEl.innerHTML = v.price;
        // Crossed-out "before" price follows the variant too (hidden when that variant isn't on sale).
        if (this.compareEl) { this.compareEl.innerHTML = v.compare || ''; this.compareEl.hidden = !v.compare; }
        if (v.options) {
          v.options.forEach((val, i) => {
            const el = this.bar.querySelector('[data-satc-opt="' + i + '"]');
            if (el) el.textContent = val;
            const sw = this.bar.querySelector('[data-satc-swatch="' + i + '"]');
            if (sw) {
              const bg = (this.swatches[i] || {})[val];
              if (bg) { sw.style.background = bg; sw.hidden = false; }
              else { sw.hidden = true; }
            }
          });
        }
        if (this.imgEl && v.image) this.imgEl.src = v.image;
      }
      // The button's label + state come straight from the real page button.
      this.mirrorButton();
    }

    add() {
      const real = this.realButton();
      if (!real || real.disabled) return;
      // Puppet-click the real add-to-cart button, exactly like Horizon's native bar.
      // The mirror reflects the real button's own feedback ("Adding…" etc).
      real.dataset.puppet = 'true';
      real.click();
    }
  }

  function upliftInitStickyAtc(scope) {
    (scope || document).querySelectorAll('[data-uplift-satc]').forEach((el) => {
      if (!el.upliftStickyAtc) el.upliftStickyAtc = new UpliftStickyAtc(el);
    });
  }

  upliftInitStickyAtc();
  document.addEventListener('shopify:section:load', (event) => upliftInitStickyAtc(event.target));
  } catch(e) { console.error(e); }
})();

})();
